import { AsyncPipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, inject } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

import { EmptyComponent, ErrorComponent, LoaderComponent, TextComponent, TitleComponent } from '@camelot/ui';
import { CamBaseModal } from '@camelot/utils';

import { CamCommunicationsService } from '../../../services/communications.service';
import { CamTranslationCommunication } from '../../../translation.service';

@Component({
  selector: 'cam-communication-error-content',
  imports: [AsyncPipe, EmptyComponent, ErrorComponent, LoaderComponent, TextComponent, TitleComponent, TranslatePipe],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss',
})
export class CommunicationErrorModal extends CamBaseModal<string, null> implements OnInit {
  private _conversationService = inject(CamCommunicationsService);

  get communicationId(): string {
    return this.modalState()?.input() ?? '';
  }

  get communicationError$() {
    return this._conversationService.communicationErrorsByCommunicationId.get$(this.communicationId);
  }

  constructor() {
    super();
    CamTranslationCommunication.getInstance();
  }

  ngOnInit() {
    this._fetch();
  }

  private _fetch() {
    if (!this.communicationId) {
      return;
    }
    this.requestState.asked();
    this._registerSubscription(
      this._conversationService.fetchConversationError$(this.communicationId).subscribe({
        complete: () => this.requestState.completed(),
        error: (error: HttpErrorResponse) => {
          this.requestState.onError(error.status, error.statusText);
        },
      })
    );
  }
}
